import axios from 'axios'
import type { App } from 'vue'
import { attachAuthInterceptors } from '@/utils/auth-interceptors'

const apiOmni = axios.create({
  baseURL: import.meta.env.VITE_OMNI_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

attachAuthInterceptors(apiOmni)

export default {
  install(app: App) {
    app.config.globalProperties.$apiOmni = apiOmni
  },
}

export { apiOmni }
